import { render, staticRenderFns } from "./PortfolioMasonryCaption.vue?vue&type=template&id=0d12e7b0&"
import script from "./PortfolioMasonryCaption.vue?vue&type=script&lang=js&"
export * from "./PortfolioMasonryCaption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports